import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { CSS_CLASS_PREFIX } from "../constants/css";
import { cssMainSelector } from "../lib/cssSelectors";
import styled from "styled-components";
import MaterialIcon from "./MaterialIcon";
import { PrimaryInverseButton } from "./Button";
import { MODALS } from "../constants/modals";
import {
  multiPhoneGroupsForOfferType,
  onePhoneSelected,
  selectedMainEntity
} from "../lib/mainEntitySelection";
import { MAIN_SELECTION_ENTITIES } from "../constants/mainSelectionEntities";
import { isPortalDataReady } from "../lib/portalData";

const ButtonMobile = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
   
    button {
      height: 35px;
      padding: 0;
      width: 35px;

      .${CSS_CLASS_PREFIX}-material-icon {
        font-size: 20px;
      }
    }
  }
`;

class PhonePickerButton extends PureComponent {
  render() {
    try {
      return this.phonePickerButton();
    } catch (e) {
      return null;
    }
  }

  phonePickerButton() {
    const { clientConfig, filter, offerType, portalData } = this.props;
    const selectedEntity = selectedMainEntity(offerType, filter);

    if (selectedEntity === MAIN_SELECTION_ENTITIES.simOnly) {
      return null;
    } else {
      const portalDataReady = isPortalDataReady(portalData, offerType);
      const preSelect =
        clientConfig.widgetOptions[offerType].preSelectPhoneFromPhoneGroup;
      const multiPhoneGroups = multiPhoneGroupsForOfferType(
        portalData,
        offerType
      );
      const onePhone = onePhoneSelected(portalData, filter);
      const showButton = multiPhoneGroups || (!onePhone && !preSelect);

      if (portalDataReady && showButton) {
        if (
          selectedEntity === MAIN_SELECTION_ENTITIES.multiPhone ||
          selectedEntity === MAIN_SELECTION_ENTITIES.singleBrand ||
          selectedEntity === MAIN_SELECTION_ENTITIES.unknown
        ) {
          return this.phonePickerButtonWithMultiPhone();
        } else if (
          selectedEntity === MAIN_SELECTION_ENTITIES.singlePhone ||
          selectedEntity === MAIN_SELECTION_ENTITIES.singlePhoneVariant
        ) {
          return this.phonePickerButtonWithSinglePhone();
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
  }

  phonePickerButtonWithMultiPhone() {
    const { small, t, updateModal } = this.props;

    return (
      <div>
        {small && (
          <ButtonMobile>
            <PrimaryInverseButton
              onClick={updateModal.bind(
                this,
                { noData: "required" },
                MODALS.phonePickerModal
              )}
            >
              <MaterialIcon>add_circle</MaterialIcon>
            </PrimaryInverseButton>
          </ButtonMobile>
        )}
        {!small && (
          <PrimaryInverseButton
            onClick={updateModal.bind(
              this,
              { noData: "required" },
              MODALS.phonePickerModal
            )}
          >
            {t("selectPhone")} <MaterialIcon>add_circle</MaterialIcon>
          </PrimaryInverseButton>
        )}
      </div>
    );
  }

  phonePickerButtonWithSinglePhone() {
    const { small, t, updateModal } = this.props;

    return (
      <div>
        {small && (
          <ButtonMobile
            onClick={updateModal.bind(
              this,
              { noData: "required" },
              MODALS.phonePickerModal
            )}
          >
            <PrimaryInverseButton>
              <MaterialIcon>edit</MaterialIcon>
            </PrimaryInverseButton>
          </ButtonMobile>
        )}
        {!small && (
          <PrimaryInverseButton
            onClick={updateModal.bind(
              this,
              { noData: "required" },
              MODALS.phonePickerModal
            )}
          >
            {t("changePhone")} <MaterialIcon>edit</MaterialIcon>
          </PrimaryInverseButton>
        )}
      </div>
    );
  }
}

PhonePickerButton.propTypes = {
  clientConfig: PropTypes.object.isRequired,
  filter: PropTypes.object.isRequired,
  offerType: PropTypes.string.isRequired,
  portalData: PropTypes.object.isRequired,
  small: PropTypes.bool,
  updateModal: PropTypes.func.isRequired
};

PhonePickerButton.defaultProps = {
  small: false
};

export default withTranslation(["phonePickerButton"])(PhonePickerButton);
